import { Box, styled, Theme, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const AuthHeadingBox = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '20px',
    marginBottom: '40px',

    [theme.breakpoints.down('tablet')]: {
      marginBottom: '32px',
    },
  };
}) as typeof Box;

export const Title = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.text.header_accent,
    fontSize: '3rem',
    fontWeight: 700,
    lineHeight: '58px',
    height: 'max-content',
    textAlign: 'center',

    [theme.breakpoints.down('tablet')]: {
      fontSize: '2rem',
      lineHeight: '38px',
    },
  };
}) as typeof Typography;

export const TitleCircle = styled(Title)({
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
}) as typeof Typography;

export const SubTitle = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.text.body,
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '22px',
    textAlign: 'center',
    whiteSpace: 'pre-line',

    [theme.breakpoints.down('tablet')]: {
      lineHeight: '23px',
    },
  };
}) as typeof Typography;
